import { useState } from 'react'

export default function Reports() {
  const [reports] = useState([
    { id: 1, title: '月度经营报告', period: '2026?', date: '2026-04-15', status: 'generated' },
    { id: 2, title: '活动数据分析', period: '2026?', date: '2026-03-31', status: 'generated' },
  ])

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📊 报表中心</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>生成和查看各类经营报?</p>

      {/* Quick Reports */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 24 }}>
        {[
          { icon: '💰', name: '营收报表', desc: '收入/订单统计' },
          { icon: '👥', name: '客户报表', desc: '客户增长分析' },
          { icon: '🎬', name: '视频报表', desc: '制作量统计' },
          { icon: '📱', name: '营销报表', desc: '触达转化分析' },
        ].map((r, i) => (
          <div key={i} style={{ background: '#fff', borderRadius: 8, padding: 20, textAlign: 'center', cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>{r.icon}</div>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>{r.name}</div>
            <div style={{ fontSize: 12, color: '#999' }}>{r.desc}</div>
          </div>
        ))}
      </div>

      {/* Generated Reports */}
      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <div style={{ padding: 16, borderBottom: '1px solid #f0f0f0' }}>
          <h3 style={{ fontSize: 14 }}>已生成的报表</h3>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>报表名称</th>
              <th style={th}>周期</th>
              <th style={th}>生成时间</th>
              <th style={th}>状?</th>
              <th style={th}>操作</th>
            </tr>
          </thead>
          <tbody>
            {reports.map(r => (
              <tr key={r.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}>{r.title}</td>
                <td style={{ ...td, color: '#666' }}>{r.period}</td>
                <td style={{ ...td, color: '#999' }}>{r.date}</td>
                <td style={td}><span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: '#fff', color: '#52c41a' }}>已完?</span></td>
                <td style={td}>
                  <button style={{ ...btn, background: '#1890ff', color: '#666' }}>查看</button>
                  <button style={{ ...btn, background: '#f5f5f5', color: '#999', marginLeft: 8 }}>下载</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
const btn = { padding: '6px 12px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
